import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import Table from 'react-bootstrap/Table';

import PopupBox from '../PopupBox.js';


import Countdown from '../Countdown.js';




export default class MultiColumn extends React.Component {
  
    constructor(props) {
        super(props);
        this.state = {
            boxesClicked: 1,         
        };
      }
      
      render() {


    this.num_boxes = 8;

    //handle the click on one of the buttons
    const handleClick = (e) => {


      

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == this.props.correct_answer)
      { 
        e.target.style.opacity = 0

        this.setState({boxesClicked: this.state.boxesClicked + 1})
        

            console.log(this.state.boxesClicked)
          if(this.state.boxesClicked == this.num_boxes)
          {
            this.props.setResult(true, this)
          }

        //
      }
      else
      {
        this.props.setResult(false, this)
      }
    };


   

    return (

      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>

      <Countdown time_allowed={15} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

          
     
        <h2 className="text-danger">{this.props.question}</h2>
        



        <div className="d-flex justify-content-center">
          <ButtonToolbar>
            <Button style={{width: "400px", height: "400px", marginLeft:"15px"}} className="massive" value="0" onMouseDown={handleClick} className="mr-3" variant={this.props.color0} size="lg">{this.props.text0}</Button>  
          </ButtonToolbar>
        </div>


        <Table className="table" style={{marginTop: "-375px", marginLeft: "30px"}}>
      
        <tbody  >
            <tr>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            </tr>
            <tr>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            </tr>
            <tr>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            </tr>

 
            <tr>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            <td><Button value="1" onMouseDown={handleClick} className="mr-1" variant={this.props.color1} size="lg">{this.props.text1}</Button></td>
            </tr>
          
         

        </tbody>
        </Table>



      </PopupBox>

    );
  }
}
